import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { HasFeature } from '@/components/Atoms/Permissions'
import { Card, CardContent } from '@/components/ui/card'
import { LicensingAgentsFeature } from '@/lib/features'
import { buildPath } from '@/routes'
import { Navigate, Outlet } from 'react-router'

export function LicensingAgenciesLayout() {
  return (
    <HasFeature
      feature={LicensingAgentsFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Breadcrumb
        label="Licensing Agencies"
        path={buildPath('/licensing-agencies')}
      />
      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[500px]">
          <Outlet />
        </CardContent>
      </Card>
    </HasFeature>
  )
}
